// removed by extract-text-webpack-plugin
module.exports = {"Container":"OnlyOnApp__Container__QynOP","Message":"OnlyOnApp__Message__2gYWN","Badges":"OnlyOnApp__Badges__175wK","Badge":"OnlyOnApp__Badge__1BvH_"};